<template>
  <div class="switch-theme-mode">
    <label id="switch" class="switch">
      <input type="checkbox" @click="toggleDarkMode" id="slider" :checked="isDarkMode" />
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LightDarkSwtichBtn",

  data() {
    return {
      isDarkMode: true,
    };
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      document.body.classList.toggle("theme-dark", this.isDarkMode);
      localStorage.setItem("theme-dark", this.isDarkMode.toString());
    },
  },
  mounted() {
    const storedDarkMode = localStorage.getItem("theme-dark");
    if (storedDarkMode) {
      this.isDarkMode = storedDarkMode === "true";
    } else {
      // Set dark mode as default for new users
      this.isDarkMode = true;
      localStorage.setItem("theme-dark", "true");
    }
    document.body.classList.toggle("theme-dark", this.isDarkMode);
  },
});
</script>